import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Forms } from '../shared/forms/forms';
import { getAllSettings, updateHeaderSettings, uploadLogo } from '../services/settings-service';
import { useSettings } from '../contexts/SettingsContext';

export const HeaderSettings = () => {
  const [fields, setFields] = useState([]);
  const [logoFile, setLogoFile]     = useState(null);
  const [logoPath, setLogoPath]     = useState('');
  const formRef = useRef();
  const { reload } = useSettings();

  const load = async () => {
    const dto = await getAllSettings();
    if (!dto) return;
    setLogoPath(dto.logoPath || '');
    setFields([
      { label: 'Address',            name: 'headerAddress',      type: 'textarea', value: dto.headerAddress || '', size: 12 },
      { label: 'Contact Name',       name: 'headerContactName',  type: 'text',     value: dto.headerContactName || '', size: 6 },
      { label: 'Phone Number',       name: 'headerPhoneNumber',  type: 'text',     value: dto.headerPhoneNumber || '', size: 6, numbersOnly: true },
      { label: 'Justification',      name: 'headerJustification',type: 'select',   value: dto.headerJustification || 'Left', size: 6,
        selectOptions: [{label:'Left',value:'Left'},{label:'Center',value:'Center'}]
      }
    ]);
  };

  useEffect(() => { load(); }, []);

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    setLogoFile(file);
  
  
   try {
     const { url } = await uploadLogo(file);
     setLogoPath(url);
     await reload();
   } catch (err) {
     console.error(err);
     // optionally show an error toast
   }
  };

  const onSubmit = async (data) => {
    // include your new LogoPath
    await updateHeaderSettings({
      headerAddress:      data.headerAddress,
      headerContactName:  data.headerContactName,
      headerPhoneNumber:  data.headerPhoneNumber,
      headerJustification:data.headerJustification,
      logoPath:           logoPath,        // ← new
    });
    // reload to pick up normalized values
    await reload();
  };

  return (
    <Box sx={{ m: 2 }}>
      {/* logo upload & preview */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2">Header Logo</Typography>
        <input
          type="file"
          accept="image/*"
          onChange={handleLogoChange}
        />
        {logoPath && (
          <Box component="img"
            src={logoPath}
            alt="Logo preview"
            sx={{ mt: 1, maxHeight: 80 }}
          />
        )}
      </Box>

      <Forms ref={formRef} fields={fields} onSubmit={onSubmit} />

      <Button
        variant="contained"
        sx={{ mt: 2 }}
        disabled={!fields.length}
        onClick={() => formRef.current.submit()}
      >
        Save Header
      </Button>
    </Box>
  );
};
